



















import { Vue, Component, Prop } from 'vue-property-decorator';
import ClickOutside from 'vue-click-outside';
import { toolTipComponents } from '@/pro/components/common/tooltip/tooltip';

const components = toolTipComponents;

@Component({
  directives: { ClickOutside },
  components,
})
export default class ToolTip extends Vue {
  @Prop()
  private message: string[];

  private isShowTooltip = false;

  private toggleTooltip() {
    this.isShowTooltip = !this.isShowTooltip;
  }
}
